// @flow
import type { ProductPayload } from '@gandi/cart';
import { useTranslator, mapTags } from '@gandi/translate';

import type { GandiFormSelectOption } from 'src/Domain/types';

export function useDomainPerksDetails(): Array<{
  label: string,
  detail?: string,
}> {
  const { __ } = useTranslator();

  return [
    {
      label: __('SSL Certificate - Standard Single address'),
      detail: __('First year free'),
    },
    {
      label: __('Privacy options'),
      detail: __('Whois privacy & email obfuscation when available'),
    },
  ];
}

export function useWebhostingPerksDetails(): Array<{
  label: string,
  detail?: string,
}> {
  const { __ } = useTranslator();

  return [
    {
      label: __(
        'Unlimited free standard SSL certificate for every site hosted.',
      ),
    },
    {
      label: __('Privacy options'),
      detail: __('Whois privacy & email obfuscation when available'),
    },
  ];
}

export function useStudioWebhostingPerksDetails(): Array<{
  label: string,
  detail?: string,
}> {
  const { __ } = useTranslator();

  return [
    {
      label: __('SSL Certificate'),
      detail: __('Secures your website and enables HTTPS.'),
    },
    {
      label: __('Whois privacy & email obfuscation'),
      detail: __(
        'Protects your personal details and email address when they would otherwise be publicly visible.',
      ),
    },
  ];
}

export function usePlanOptions(
  payload: Partial<ProductPayload>,
  diffMonthly?: string,
): Array<GandiFormSelectOption<number>> {
  const { __ } = useTranslator();

  const yearlyText = diffMonthly
    ? mapTags(__('yearly [[duration]]'), () => ({
        duration: <strong>{`(${diffMonthly})`}</strong>,
      }))
    : __('Yearly');
  // The value is the duration of the subscription in months
  const monthly = { text: __('Monthly'), value: 1 };
  const yearly = { text: yearlyText, value: 12 };

  // $FlowFixMe[incompatible-return] mapTags return a React.MixedElement
  if (payload.duration === 12 && payload.size === 'essential') return [yearly];

  // $FlowFixMe[incompatible-return] mapTags return a React.MixedElement
  return [monthly, yearly];
}
